module.exports = __webpack_public_path__ + "img/addMembers.914b625a.png";